"use strict";

/**
 * @classdesc
 * Abstrakte Wrapperklasse für eine MultiPunkt-Geometrie.
 *
 * @class
 * @abstract
 * @extends gc.gis.geom.GCGeometry
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {T} multipoint gewrappte MultiPunkt-Geometrie-Instanz
 */
gc.gis.geom.GCMultiPoint = function(multipoint)
{
    gc.gis.geom.GCGeometry.call(this, multipoint);
};
gc.gis.geom.GCMultiPoint.prototype = Object.create(gc.gis.geom.GCGeometry.prototype);

/**
 * Liefert die Anzahl der Punkt des MultiPoints.
 *
 * @abstract
 * @method
 * @return {number} Anzahl der Punkte
 * @public
 */
gc.gis.geom.GCMultiPoint.prototype.numPoints = gc.gis.abstractMethod;

/**
 * Liefert ein Punkt anhand des Index.
 *
 * @abstract
 * @method
 * @param {number} index Index
 * @return {gc.gis.geom.GCPoint} der Punkt zum angegebenen Index
 * @public
 */
gc.gis.geom.GCMultiPoint.prototype.getPoint = gc.gis.abstractMethod;